import { render } from "./EventCard.vue?vue&type=template&id=2c0be2ea&scoped=true"
import script from "./EventCard.vue?vue&type=script&lang=js"
export * from "./EventCard.vue?vue&type=script&lang=js"

import "./EventCard.vue?vue&type=style&index=0&id=2c0be2ea&scoped=true&lang=css"

import exportComponent from "/Users/sindreglomnes/Documents/Dataing/Testing/VueCourse/real-world-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c0be2ea"]])

export default __exports__